import { NavigationTableInputDirective } from './navigation-table-input.directive';

export class NavigationTableInputDirectiveEvent {
	source: NavigationTableInputDirective;
	suivantBas: boolean;

	constructor(source: NavigationTableInputDirective, suivantBas: boolean) {
		this.source = source;
		this.suivantBas = suivantBas;
	}
}
